"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createBusinessLoggerNoop = void 0;
const createBusinessLoggerNoop = () => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const noopLog = (params, context) => {
        return new Promise(() => {
            console.warn('The logger is not implemented');
        });
    };
    return {
        logger: {
            log: noopLog,
        },
        reportBi: noopLog,
    };
};
exports.createBusinessLoggerNoop = createBusinessLoggerNoop;
//# sourceMappingURL=businessLogger.js.map